module.exports = __webpack_public_path__ + "static/img/bgPro.31851c48.png";